import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  QueryList,
  ViewChildren
} from '@angular/core';
import { Subscription } from 'rxjs';

interface LandingCard {
  image: string;
  titleKey: string;
  descriptionKey: string;
  altKey: string;
}

interface GalleryItem {
  image: string;
  altKey: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('reveal') revealElements!: QueryList<ElementRef<HTMLElement>>;

  showScrollTop = false;

  readonly services: LandingCard[] = [
    {
      image: 'assets/images/vagott-virag.jpg',
      titleKey: 'landing.services.cut.title',
      descriptionKey: 'landing.services.cut.description',
      altKey: 'landing.services.cut.alt'
    },
    {
      image: 'assets/images/tavaszi_csokor.jpg',
      titleKey: 'landing.services.bouquet.title',
      descriptionKey: 'landing.services.bouquet.description',
      altKey: 'landing.services.bouquet.alt'
    },
    {
      image: 'assets/images/orchidea.jpg',
      titleKey: 'landing.services.potted.title',
      descriptionKey: 'landing.services.potted.description',
      altKey: 'landing.services.potted.alt'
    }
  ];

  readonly gallery: GalleryItem[] = [
    {
      image: 'assets/images/viragdoboz.jpg',
      altKey: 'landing.gallery.item1'
    },
    {
      image: 'assets/images/peaonia.jpg',
      altKey: 'landing.gallery.item2'
    },
    {
      image: 'assets/images/csokrok-vagott-viragok.jpg',
      altKey: 'landing.gallery.item3'
    },
    {
      image: 'assets/images/cserepes_orchidea.jpg',
      altKey: 'landing.gallery.item4'
    }
  ];

  private revealObserver?: IntersectionObserver;
  private revealElementsSubscription?: Subscription;

  ngAfterViewInit(): void {
    this.initRevealObserver();
  }

  ngOnDestroy(): void {
    this.revealObserver?.disconnect();
    this.revealElementsSubscription?.unsubscribe();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.showScrollTop = window.scrollY > 520;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private initRevealObserver(): void {
    if (!('IntersectionObserver' in window)) {
      this.revealElements.forEach((element) => {
        element.nativeElement.classList.add('is-visible');
      });
      return;
    }

    this.revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.revealObserver?.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16
      }
    );

    this.observeRevealElements();
    this.revealElementsSubscription = this.revealElements.changes.subscribe(() => {
      this.observeRevealElements();
    });
  }

  private observeRevealElements(): void {
    this.revealElements.forEach((element) => {
      this.revealObserver?.observe(element.nativeElement);
    });
  }
}
